import CurrencyFormatter from "common/CurrencyFormatter";
import { ReadOnlyWrapper } from "components/common/ReadOnlyWrapper";
import Checkbox from "components/UI/Checkbox";
import InputComponent from "components/UI/Input";
import { Color } from "lib/styles";
import React from "react";
import { Main } from "styles/themeColors";
import RichTextEditor from "view/RichTextEditor";

/**
 * 
 * @param field Field to render
 * @param id  Id of the field
 * @param label  Label of the field
 * @returns  Checkbox component
 */
export const renderCheckbox = (field: any, id: string, label: string, infoIconText: string = '', permissionCode = '') => (
    <Checkbox
        {...field}
        id={id}
        appearance="none"
        className='align-checkbox'
        checkboxSize="s"
        checked={field.value}
        label={label}
        onChange={(checked: boolean) => field.onChange(checked)}
        theme={field.value ? 'brandLight' : 'lightGray'}
        bgColor={field.value ? Main.brandLight : Main.accent}
        infoIconText={infoIconText}
        permissionCode={permissionCode}
    />
);

/**
 * 
 * @param field Field to render
 * @param id  Id of the field
 * @param label  Label of the field
 * @param placeholder  Placeholder of the field
 * @param errorMessage  Error message of the field
 * @param isInvalid  Is field invalid
 * @returns  Input component
 */
export const renderInput = (field: any, id: string, label: string, placeholder: string, errorMessage: string | undefined, isInvalid: boolean, isOptional: boolean = false, infoIconText = '',readOnly = false) => (

    <InputComponent
        {...field}
        id={id}
        labelName={label}
        placeholder={placeholder}
        errorMessage={errorMessage}
        isInvalid={isInvalid}
        width="100%"
        displayAsterisk={!isOptional}
        choiceOptional={isOptional}
        infoIconText={infoIconText}
        productRedesignFlag
        readOnly={readOnly}
    />
);

/**
 * 
 * @param field  Field to render
 * @param placeholder  Placeholder of the field
 * @param maxLength  Max length of the field
 * @param showCharactersCount  Show characters count
 * @param isInvalid  Is field invalid
 * @param error  Error message
 * @param labelComponent  Label component
 * @returns  Rich text editor component
 */
export const renderRichTextEditor = (field: any,
    placeholder: string, maxLength: number, error: any, labelComponent: React.ReactNode
) => (
    <>
        {labelComponent && labelComponent}
        <RichTextEditor
            {...field}
            onBlur={(value: string) => {
                field.onChange(value);
            }}
            placeholder={placeholder}
            maxLength={maxLength}
            showCharactersCount={!error}
            isInvalid={!!error}
            disabled={false}
            productRedesignFlag
        />
        {!!error && <span style={{ fontSize: 12, lineHeight: '24px', color: Color.error }}>{error}</span>}

    </>
);


/**
 * 
 * @param field Field to render
 * @param errors Errors object
 * @returns CurrencyFormatter component
 */
export const renderCurrencyFormatter = (field: any, error: any, currencyIso: string, className: string, readOnly = false) => (
    <ReadOnlyWrapper readOnly={readOnly}>
        <CurrencyFormatter
            {...field}
            value={field.value}
            onChange={(value) => {
                field.onChange(value);
            }}
            error={error}
            currencyIso={currencyIso}
            className={className}
            textAlign='left'
        />

        {error ? <span style={{ color: Color.error, fontSize: 12, lineHeight: '16px' }}>{error}</span> : null}
    </ReadOnlyWrapper>
);


